export const fullName = employee => {
  return `${employee.first_name} ${employee.middle_name} ${employee.last_name} ${employee.surname}`
}
